
import Vue from "vue";
import Component from "vue-class-component";

type Column = {
  text: string;
  align: string;
  sortable: string;
  value: string;
  width: string;
  visible: boolean;
};

@Component({
  props: {
    value: {
      required: true,
      type: Array,
    },
    colunas: {
      required: true,
      type: Array as () => Column[],
    },
  },
})
export default class ColumnsSelectionButton extends Vue {
  get selected() {
    const a =  this.$props.colunas.reduce((result, current) => {
      return {
        ...result,
        [current.value]: !this.$props.value.includes(current.value) && current.visible == undefined ? true : current.visible,
      };
    }, {});

    return a;
  }

  mounted() {
    this.$emit("input", this.$props.colunas.filter(el => !(el.visible == undefined ? true : el.visible)).map(el => el.value));
  }

  get listaColunas() {
    return this.$props.colunas.filter(el => el.value !== 'acoes');
  }

  onColunaCheckboxChange(col: any, state: boolean) {
    if (!state) {
      this.$emit("input", [...this.$props.value, col.value]);
      return;
    }

    this.$emit(
      "input",
      this.$props.value.filter((el) => el !== col.value)
    );
  }
}
